/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * BankDetailsApi - axios parameter creator
 * @export
 */
export const BankDetailsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new bank-detail
         * @param {CreateBankDetailDto} createBankDetailDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bankDetailsControllerCreate: (createBankDetailDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createBankDetailDto' is not null or undefined
            assertParamExists('bankDetailsControllerCreate', 'createBankDetailDto', createBankDetailDto);
            const localVarPath = `/bank-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createBankDetailDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a new bank-detail using payload from the embedded form
         * @param {CreateBankDetailDto} createBankDetailDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerCreateV2: (createBankDetailDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createBankDetailDto' is not null or undefined
            assertParamExists('bankDetailsControllerCreateV2', 'createBankDetailDto', createBankDetailDto);
            const localVarPath = `/v2/bank-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createBankDetailDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all bank-details for a workspace.
         * @param {string} workspaceId
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerFindAll: (workspaceId, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('bankDetailsControllerFindAll', 'workspaceId', workspaceId);
            const localVarPath = `/bank-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get bank-detail by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bankDetailsControllerFindOne', 'id', id);
            const localVarPath = `/bank-details/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a bank-detail by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerRemove: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bankDetailsControllerRemove', 'id', id);
            const localVarPath = `/bank-details/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set the selected bank account as default
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerSetDefault: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bankDetailsControllerSetDefault', 'id', id);
            const localVarPath = `/bank-details/{id}/set-default`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an existing bank-detail
         * @param {string} id
         * @param {UpdateBankDetailDto} updateBankDetailDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bankDetailsControllerUpdate: (id, updateBankDetailDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bankDetailsControllerUpdate', 'id', id);
            // verify required parameter 'updateBankDetailDto' is not null or undefined
            assertParamExists('bankDetailsControllerUpdate', 'updateBankDetailDto', updateBankDetailDto);
            const localVarPath = `/bank-details/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateBankDetailDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an existing bank-detail using payload from the embedded form
         * @param {string} id
         * @param {UpdateBankDetailDto} updateBankDetailDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerUpdateV2: (id, updateBankDetailDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bankDetailsControllerUpdateV2', 'id', id);
            // verify required parameter 'updateBankDetailDto' is not null or undefined
            assertParamExists('bankDetailsControllerUpdateV2', 'updateBankDetailDto', updateBankDetailDto);
            const localVarPath = `/v2/bank-details/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateBankDetailDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BankDetailsApi - functional programming interface
 * @export
 */
export const BankDetailsApiFp = function (configuration) {
    const localVarAxiosParamCreator = BankDetailsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new bank-detail
         * @param {CreateBankDetailDto} createBankDetailDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bankDetailsControllerCreate(createBankDetailDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bankDetailsControllerCreate(createBankDetailDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a new bank-detail using payload from the embedded form
         * @param {CreateBankDetailDto} createBankDetailDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerCreateV2(createBankDetailDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bankDetailsControllerCreateV2(createBankDetailDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all bank-details for a workspace.
         * @param {string} workspaceId
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerFindAll(workspaceId, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bankDetailsControllerFindAll(workspaceId, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get bank-detail by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bankDetailsControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a bank-detail by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerRemove(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bankDetailsControllerRemove(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Set the selected bank account as default
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerSetDefault(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bankDetailsControllerSetDefault(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an existing bank-detail
         * @param {string} id
         * @param {UpdateBankDetailDto} updateBankDetailDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bankDetailsControllerUpdate(id, updateBankDetailDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bankDetailsControllerUpdate(id, updateBankDetailDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an existing bank-detail using payload from the embedded form
         * @param {string} id
         * @param {UpdateBankDetailDto} updateBankDetailDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerUpdateV2(id, updateBankDetailDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bankDetailsControllerUpdateV2(id, updateBankDetailDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BankDetailsApi - factory interface
 * @export
 */
export const BankDetailsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BankDetailsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new bank-detail
         * @param {CreateBankDetailDto} createBankDetailDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bankDetailsControllerCreate(createBankDetailDto, options) {
            return localVarFp
                .bankDetailsControllerCreate(createBankDetailDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new bank-detail using payload from the embedded form
         * @param {CreateBankDetailDto} createBankDetailDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerCreateV2(createBankDetailDto, options) {
            return localVarFp
                .bankDetailsControllerCreateV2(createBankDetailDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all bank-details for a workspace.
         * @param {string} workspaceId
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerFindAll(workspaceId, page, pageSize, sortBy, options) {
            return localVarFp
                .bankDetailsControllerFindAll(workspaceId, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get bank-detail by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerFindOne(id, options) {
            return localVarFp
                .bankDetailsControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a bank-detail by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerRemove(id, options) {
            return localVarFp
                .bankDetailsControllerRemove(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set the selected bank account as default
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerSetDefault(id, options) {
            return localVarFp
                .bankDetailsControllerSetDefault(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing bank-detail
         * @param {string} id
         * @param {UpdateBankDetailDto} updateBankDetailDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        bankDetailsControllerUpdate(id, updateBankDetailDto, options) {
            return localVarFp
                .bankDetailsControllerUpdate(id, updateBankDetailDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing bank-detail using payload from the embedded form
         * @param {string} id
         * @param {UpdateBankDetailDto} updateBankDetailDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankDetailsControllerUpdateV2(id, updateBankDetailDto, options) {
            return localVarFp
                .bankDetailsControllerUpdateV2(id, updateBankDetailDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * BankDetailsApi - object-oriented interface
 * @export
 * @class BankDetailsApi
 * @extends {BaseAPI}
 */
export class BankDetailsApi extends BaseAPI {
    /**
     *
     * @summary Create a new bank-detail
     * @param {CreateBankDetailDto} createBankDetailDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BankDetailsApi
     */
    bankDetailsControllerCreate(createBankDetailDto, options) {
        return BankDetailsApiFp(this.configuration)
            .bankDetailsControllerCreate(createBankDetailDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new bank-detail using payload from the embedded form
     * @param {CreateBankDetailDto} createBankDetailDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankDetailsApi
     */
    bankDetailsControllerCreateV2(createBankDetailDto, options) {
        return BankDetailsApiFp(this.configuration)
            .bankDetailsControllerCreateV2(createBankDetailDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all bank-details for a workspace.
     * @param {string} workspaceId
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankDetailsApi
     */
    bankDetailsControllerFindAll(workspaceId, page, pageSize, sortBy, options) {
        return BankDetailsApiFp(this.configuration)
            .bankDetailsControllerFindAll(workspaceId, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get bank-detail by Id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankDetailsApi
     */
    bankDetailsControllerFindOne(id, options) {
        return BankDetailsApiFp(this.configuration)
            .bankDetailsControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a bank-detail by Id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankDetailsApi
     */
    bankDetailsControllerRemove(id, options) {
        return BankDetailsApiFp(this.configuration)
            .bankDetailsControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set the selected bank account as default
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankDetailsApi
     */
    bankDetailsControllerSetDefault(id, options) {
        return BankDetailsApiFp(this.configuration)
            .bankDetailsControllerSetDefault(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing bank-detail
     * @param {string} id
     * @param {UpdateBankDetailDto} updateBankDetailDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BankDetailsApi
     */
    bankDetailsControllerUpdate(id, updateBankDetailDto, options) {
        return BankDetailsApiFp(this.configuration)
            .bankDetailsControllerUpdate(id, updateBankDetailDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing bank-detail using payload from the embedded form
     * @param {string} id
     * @param {UpdateBankDetailDto} updateBankDetailDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankDetailsApi
     */
    bankDetailsControllerUpdateV2(id, updateBankDetailDto, options) {
        return BankDetailsApiFp(this.configuration)
            .bankDetailsControllerUpdateV2(id, updateBankDetailDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
